import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { union_type, class_type, record_type, list_type, bool_type, obj_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dashboard_ToggleNotificationRequest_$reflection, Dashboard_ToggleNotificationRequest, File_FileListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { truncate, mapIndexed, isEmpty, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Filter } from "../../../Kundenportal.Types.fs.js";
import { Page } from "../Files/Types.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_2 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import * as react from "react";
import { bfsTile, navigationArrow } from "../Shared/Tile.fs.js";
import { notificationBox } from "./Shared.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";

export class Model extends Record {
    constructor(GlobalDispatch, NavigateTo, Loading, Data, Benachrichtigung, SavingToggle) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.Loading = Loading;
        this.Data = Data;
        this.Benachrichtigung = Benachrichtigung;
        this.SavingToggle = SavingToggle;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.NeusteDokumente.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["Loading", bool_type], ["Data", list_type(File_FileListItem_$reflection())], ["Benachrichtigung", bool_type], ["SavingToggle", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "NavigateToList", "ToggleBenachrichtigung", "NotificationToggled"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.NeusteDokumente.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(File_FileListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(File_FileListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export function Http_loadFiles() {
    const response = fetch("/api/file?page=1&onlyNew=false", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(File_FileListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_setNotificationForNeueDokumente(enabled) {
    const payload = new Dashboard_ToggleNotificationRequest(enabled);
    return sendJson("/api/dashboard/set-notification-for-neue-dokumente", toString(0, Auto_generateBoxedEncoder_437914C6(Dashboard_ToggleNotificationRequest_$reflection(), undefined, undefined, undefined)(payload)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, props.NavigateTo, true, empty(), false, true), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre neusten Dokumente können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, model.Benachrichtigung, model.SavingToggle), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, msg.fields[0].fields[0].Items, model.Benachrichtigung, false), Cmd_none()];
            }
        case 2: {
            model.NavigateTo(new Page(1, new Filter(1, [])));
            return [model, Cmd_none()];
        }
        case 3: {
            const newValue = !model.Benachrichtigung;
            return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, model.Data, newValue, false), request(Http_setNotificationForNeueDokumente, newValue, (Item_2) => (new Msg(4, [Item_2])))];
        }
        case 4:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre neuen Benachrichtigungseinstellungen können zur Zeit leider nicht gespeichert werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, model.Data, !model.Benachrichtigung, false), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, model.Data, model.Benachrichtigung, false), Cmd_none()];
            }
        default:
            return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, model.Benachrichtigung, true), request(Http_loadFiles, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\NeusteDokumente.fs") + "#L") + int32ToString(value_2(107))) + ";") + "Dashboard.Shared.DashboardProps", value_2("View"), (props) => {
    let matchValue_2, children_16, children_14;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const titleActions = react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(2, []));
        },
        className: "",
    }, navigationArrow);
    const footer = model_1.Loading ? undefined : notificationBox("Benachrichtigung", model_1.Benachrichtigung, model_1.SavingToggle, (_arg_3) => {
        dispatch(new Msg(3, []));
    }, "Neuste-Dokumente-Toggle");
    return bfsTile("Neueste Dokumente", titleActions, undefined, (matchValue_2 = isEmpty(model_1.Data), model_1.Loading ? spinner : (matchValue_2 ? react.createElement("div", {
        className: "has-text-centered",
    }, "Keine Dokumente vorhanden") : ((children_16 = [(children_14 = mapIndexed((index, doc) => {
        let children_4, copyOfStruct, children_10, children_8;
        const children_12 = [(children_4 = [(copyOfStruct = (index + 1), int32ToString(copyOfStruct))], react.createElement("div", {
            className: "dokument-nummer",
        }, ...children_4)), (children_10 = [react.createElement("div", {
            className: "dokument-name",
            title: doc.Titel,
        }, doc.Titel), (children_8 = [asString(doc.Datum)], react.createElement("div", {
            className: "is-size-7 has-text-grey-light",
        }, ...children_8))], react.createElement("div", {
            className: "dokument-data",
        }, ...children_10))];
        return react.createElement("li", {
            key: doc.Id,
        }, ...children_12);
    }, truncate(3, model_1.Data)), react.createElement("ul", {}, ...children_14))], react.createElement("div", {
        className: "dokumente",
    }, ...children_16))))), footer);
}, undefined, undefined, "Of");

//# sourceMappingURL=NeusteDokumente.fs.js.map
